import React, { useState, useEffect } from "react";
import { useRemote, getIcon, useStorage } from '../../Utils/Utils';
import { gicsSectors } from '../../Utils/DummyData';
import withCraigsDocs from "./withCraigsDocs";
import Table from "../../components/Table/Table"
import LibraryTableRow from "./LibraryTableRow";
import { useLocation, useHistory } from "react-router-dom";
import { canUseCompare, compareLinkForDoc } from "../ComparePage/versionApi";
import { AlertCircle, Mail, Send } from "react-feather";
import "./CraigsLibraryTable.scss";


const CraigsLibraryTable = ({ craigsDocs, onCraigsDocClick, onDeliveryClick, filterOnclick }) => {
	const [data, setData] = useState([])
	const [expandedRows, setExpandedRows] = useState([])

	const [tickers, setTickers] = useState([])
	const [models, setModels] = useState([])
	const [modelsLoading, setModelsLoading] = useState(true)
	const [me, setMe] = useState({})

	const storage = useStorage();
	const remote = useRemote();
	const location = useLocation()
	const history = useHistory()
	const showPortalInfo = me && me.perms && me.perms.includes("VIEW_PORTAL_INFORMATION")
	// Compare is gated like the /compare route itself (RES-561; EDIT-only since
	// follow-up item 1 hid compare from external managers — policy lives in
	// versionApi.canUseCompare).
	const canCompare = canUseCompare(me)

	// Opens the compare view for this published doc — against the previous published
	// version when one exists, else against the current draft. The displayed doc list
	// travels in location.state so the compare header can step Previous/Next Doc.
	const onCompareClick = (document) => {
		const index = data.findIndex((d) => d.docId === document.docId)
		const link = compareLinkForDoc(data, index)
		if (link) history.push(link)
	}

	useEffect(() => {
		storage.getOrFetch("/crm/tickers").then(setTickers)
		remote.get("/crm/tickers/models").then((resp) => {
			setModels(resp)
			setModelsLoading(false)
		});
		storage.getOrFetch("/crm/me").then(setMe)
	}, [])

	useEffect(() => {
		setData(craigsDocs)
		// if there is a searchQuery in the url, open the appropriate publication Settings
		if (craigsDocs && location && location.search) {
			let noteSettingsSearchParamArray = location.search
				.split(/[=,?]/g)
				.filter(val => val !== "" && val !== "note-settings")
				.map((val) => parseInt(val))
			setExpandedRows(noteSettingsSearchParamArray)
		}
	}, [JSON.stringify(craigsDocs)])


	const getImage = (t) => {
		const sector = gicsSectors.find(s => s.name === t)
		const theTicker = tickers && tickers.find(ticker => ticker.ric === t)

		if (theTicker) return theTicker.logo
		else if (sector) return sector.image
		else return ""
	}

	const headerWidths = showPortalInfo ? ["80px", "50px", "180px", "320px", "160px", "90px", "80px", "50px", "50px", "50px", "50px", "50px", "50px",] : ["130px", "180px", "320px", "160px", "90px", "80px", "50px", "50px", "50px", "50px", "50px", "50px",]
	const headers = showPortalInfo ? [
		"Date",
		"",
		"Coverage",
		"Title",
		"Author",
		"",
		"",
		{
			text: (
				<div className='sorting-header extra-space' onClick={() => filterOnclick ? filterOnclick("delivered") : null}>
					<Send className="colour-text-positive" size={16} />
				</div>
			)
		},
		{
			text: (
				<div className='sorting-header extra-space' onClick={() => filterOnclick ? filterOnclick("failed") : null}>
					<AlertCircle className="colour-text-danger" size={16} />
				</div>
			)
		},
		{
			text: (
				<div className='sorting-header extra-space' onClick={() => filterOnclick ? filterOnclick("read") : null}>
					<Mail className="colour-text-purple" size={16} />
				</div>
			)
		},
		getIcon("views", "16px"),
		getIcon("downloads", "16px"),
		getIcon("modalDownloads", "16px")] :
		[
			"Date",
			"Coverage",
			"Title",
			"Author",
			"",
			"",
			{
				text: (
					<div className='sorting-header extra-space' onClick={() => filterOnclick ? filterOnclick("delivered") : null}>
						<Send className="colour-text-positive" size={16} />
					</div>
				)
			},
			{
				text: (
					<div className='sorting-header extra-space' onClick={() => filterOnclick ? filterOnclick("failed") : null}>
						<AlertCircle className="colour-text-danger" size={16} />
					</div>
				)
			},
			{
				text: (
					<div className='sorting-header extra-space' onClick={() => filterOnclick ? filterOnclick("read") : null}>
						<Mail className="colour-text-purple" size={16} />
					</div>
				)
			},
			getIcon("views", "16px"),
			getIcon("downloads", "16px"),
			getIcon("modalDownloads", "16px")
		]

	const dataMap = data.map((document, idx) => {

		return <LibraryTableRow
			data={document}
			idx={idx}
			key={idx}
			tickers={tickers}
			expandedRows={expandedRows}
			setExpandedRows={setExpandedRows}
			getImage={getImage}
			onCraigsDocClick={onCraigsDocClick}
			onDeliveryClick={onDeliveryClick}
			models={models}
			modelsLoading={modelsLoading}
			showPortalInfo={showPortalInfo}
			filterOnclick={filterOnclick}
			onCompareClick={canCompare ? onCompareClick : null}
		/>
	});

	return (
		<>
			<Table
				id="craigs-library-table"
				headerWidths={headerWidths}
				minWidth={1250}
				headers={headers}
				dataMap={dataMap}
				// if no results, message gets rendered in RemoteData.js by withCraigsDocs wrapper.
			/>
		</>
	);
}

export default withCraigsDocs(CraigsLibraryTable);

export const RawCraigsLibraryTable = CraigsLibraryTable;
